<div class="dropdown-container">
	<button
		mat-stroked-button
		[ngClass]="isOpen ? 'filter-button-focused' : 'filter-button-not-focused'"
		(click)="toggleDropdown()"
	>
		<ng-container *ngIf="showLabel; else selectedLabel">
			<span class="filter-button-text">{{ "trip duration" | i18next: { format: "capitalize" } }}</span>
		</ng-container>

		<ng-template #selectedLabel>
			<span class="filter-button-label filter-button-label-not-focused">
				{{ "trip duration" | i18next: { format: "capitalize" } }}
			</span>
			<span
				class="filter-button-text"
				[ngClass]="filterButtonTextClass"
			>
				{{ optionSelected }}
			</span>
		</ng-template>

		<mat-icon>{{ isOpen ? "arrow_drop_up" : "arrow_drop_down" }}</mat-icon>
	</button>

	<div
		class="dropdown-panel"
		*ngIf="isOpen"
		cdkTrapFocus
		cdkTrapFocusAutoCapture="true"
		(keydown.escape)="onCancel()"
	>
		<p class="trip-duration-description">{{ "trip duration description" | i18next: { format: "capitalize" } }}</p>

		<form
			#form="ngForm"
			novalidate
		>
			<mat-form-field
				appearance="outline"
				style="width: 100%"
			>
				<mat-label>{{ "duration" | i18next: { format: "capitalize" } }}</mat-label>
				<input
					matInput
					[(ngModel)]="timeInput"
					name="durationTime"
					#timeInputRef="ngModel"
					placeholder="hh:mm"
					(keypress)="blockNonTimeCharacters($event)"
					(keyup)="onKeyup($event, timeInputRef)"
					(blur)="onBlur()"
				/>
				<!-- (ngModelChange)="onTimeInputChange(timeInputRef)" -->
				<mat-error *ngIf="timeInputRef.control?.hasError('validWithDuration') && timeInputRef.touched">
					Invalid format. Max 15:00 (hh:mm).
				</mat-error>
			</mat-form-field>
		</form>

		<p class="note">1-15 hours (15 min. increments)</p>

		<mat-slider
			min="0"
			max="60"
			step="1"
			[value]="durationInMinutes / 15"
			(input)="onSliderChange($event.value)"
			[attr.aria-label]="'duration slider' | i18next"
		></mat-slider>

		<div class="slider-range-labels">
			<span>0</span>
			<span>15</span>
		</div>

		<div class="action-button-container">
			<app-action-button
				title="cancel"
				type="outlined-1"
				[style.marginRight.px]="16"
				(buttonClicked)="onCancel()"
			></app-action-button>

			<app-action-button
				title="apply"
				(buttonClicked)="onApply()"
				[disabled]="timeInputRef.control?.hasError('validWithDuration') && timeInputRef.touched"
			></app-action-button>
		</div>
	</div>
</div>
